module.exports = __webpack_public_path__ + "static/media/deportes.802445ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wish-list/deportes.jpg
// module id = 1066
// module chunks = 0